// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"148":"acd009ae","180":"91df3865","225":"52c59fa4","331":"1fb126d0","409":"f93b55dd","416":"e140935f","449":"6e27692c","455":"59a37768","472":"ab12d276","591":"83b8e4b1","604":"e0ec2413","607":"a15e5884","703":"5c573a1a","782":"8ebdc870","847":"517c6166"}[chunkId] + ".chunk.js";
};